<style lang="scss" scoped>

.list-enter-active,
.list-leave-active {
  transition: transform 1s;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
}

</style>

<template>
    <Content>
        <div class="page-header d-print-none mb-2">
            <div class="row align-items-center">
              <div class="col">
                <!-- Page pre-title -->
                <div class="page-pretitle">
                    Anlegen & Auswählen
                </div>
                <h2 class="page-title">
                    Schläge
                </h2>
              </div>
              
              <div class="col-auto ms-auto d-print-none">
                <div class="btn-list">
                   <span v-show="profileYearList.length > 0" class="d-sm-inline">
                    <select v-model="year" class="form-select">
                        <option v-for="option in profileYearList" v-bind:key="option.value" v-bind:value="option.value" v-text="option.label"></option>
                    </select>
                  </span>
                  <a href="#" class="btn btn-success d-none d-sm-inline-block text-white bg-green" @click="openNewModal">
                    <!-- Download SVG icon from http://tabler-icons.io/i/plus -->
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                    Neuen Schlag anlegen
                  </a>
                  <a href="#" class="btn btn-success d-sm-none btn-icon text-white bg-green" aria-label="" @click="openNewModal">
                    <!-- Download SVG icon from http://tabler-icons.io/i/plus -->
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                  </a>
                </div>
              </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mt-2 mb-0">
              <Alert type="success" :show="alertNew">
                 <template v-slot:title>Neuer Schlag angelegt</template>
                 An erster Stelle in der Liste finden Sie den neu angelegten Schlag. Die automatisch zugeordnete 
                 Wetterstation können Sie jederzeit in der Bewässerungs-App unter
                 <a class="content-link" href="https://www.alb-bayern.de/app" target="_blank">www.alb-bayern.de/app</a> anpassen. 
              </Alert> 
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div v-visible="loading" class="progress progress-sm mb-2">
                    <div class="progress-bar progress-bar-indeterminate bg-green"></div>
                </div>
                <div v-show="profilesByYear.length > 0" class="card">
                  <div class="list-group list-group-flush list-group-hoverable">
                    <transition-group name="fade_" tag="div">
                    <div v-for="profile in profilesByYear" v-bind:key="profile.id" class="list-group-item">
                        <router-link to="/" @click="setProfile(profile)">
                            <ProfileItem :profile="profile"></ProfileItem>
                        </router-link>
                    </div>
                    </transition-group>
                  </div>
                </div>       
            </div>
        </div>
    </Content>
    
    <NewProfile ref="newProfile" :profileYear="year" v-on:submit="submitNewModal" :key="modalKey"></NewProfile>
    
</template>

<script>

import axios from 'axios';
import Content from '@/components/Content.vue';
import ProfileItem from '@/components/profile/ProfileItem.vue';
import NewProfile from '@/components/profile/NewProfile.vue';
import Alert from '@/components/Alert.vue';

export default {
    name: 'About',
    components: {
        Content,
        ProfileItem,
        NewProfile,
        Alert
    },
    inject: [
        'state',
        'config'
    ],
    data: function () {
        return {
            year: 0,
            loading: false,
            alertNew: false,
            modalKey: 0
        }
    },
    computed: {
        profileYearList: function () {
            let profile_years = this.getProfilesYears();
        
            return profile_years.map( function (item) {
                return {
                    label: item.toString(),
                    value: item
                }
            });
        },
        profilesByYear: function () {
            let self = this;
        
            let profiles = this.state.profile.list
                .filter(function (item) {
                    return item.crop.vegetationYears.includes(self.year);
                })
                .map(function (item) {
                    item = Object.assign({}, item);
                    item.year = self.year;
                    return item;
            });
    
            profiles = profiles.sort(function(p1, p2) {
               let c1 = 0;
               
               if (p1.allIrrigationsCompleted == true && p2.allIrrigationsCompleted == false) {
                    c1 += 10
               } else if (p1.allIrrigationsCompleted == false && p2.allIrrigationsCompleted == true) {
                    c1 += -10
               }
               
               if (p2.id === self.state.profile.id ) {
                    c1 += 5
               } else if (p1.id === self.state.profile.id ) {
                    c1 += -5
               }
               
               if (p1.id < p2.id ) {
                    c1 += 1
               } else {
                    c1 += -1
               }
                              
               return Math.min(Math.max(c1,-1), 1)
            });
            
            return profiles;
        }
    },
    methods: {
        openNewModal: function () {
            this.modalKey = this.modalKey + 1;
            this.$nextTick(function() { 
                this.$refs.newProfile.openModal();
            });
        },
        submitNewModal: function (profile) {
            let self = this;
            
            /*
            let profileId = null;
            if (this.profilesByYear.length > 0) {
               profileId = parseInt(this.profilesByYear[0].id);
            }
            */
            
            self.alertNew = false;
            self.addData(profile, function () {
                self.alertNew = true;
            });
        },
        getProfilesYears: function () {
            var set = new Set();
            this.state.profile.list.forEach(function (item) {
                if (item.crop && Array.isArray(item.crop.vegetationYears)) {
                    item.crop.vegetationYears.forEach(function (year) {
                        set.add(year);
                    });
                }
            });
            return Array.from(set).sort().reverse();
        },
        setProfile: function (profile) {
            this.state.actions.profile.setId(profile.id);
            this.state.actions.profile.set({year: this.year});
        },
        checkProfileSelection: function () {  
            let self = this;
        
            self.$nextTick(function() {
                let profile_years = self.getProfilesYears();
            
                if ( !profile_years.includes(self.year) ) {
                    self.year = profile_years[0];
                }
            });
        },
        profileById: function (profileId) {       
            let profiles = this.state.profile.list.filter( function (profile) {
               return parseInt(profile.id) === parseInt(profileId);
            });
            
            if (profiles.length > 0) {
                return profiles[0];
            }
        },
        fetchData: function (callback) {
            let self = this;
                        
            let query = {
                query: `
                query {
                    user {
                        profiles {
                            id
                            label
                            year
                            area
                            crop {
                                id
                                vegetationYears
                                isPerennialCrop
                                isRowCrop
                            }
                            weatherstation {
                                id
                                label
                                provider
                                altitude
                            }
                            allIrrigationsCompleted
                            waterPointId
                            totalWithdrawal
                        }
                        loggedIn
                    }
                }
                `,      
                variables: {
                }           
            }
            
            const request = Object.assign({}, self.config.request, {data: query});
            self.loading = true;
            
            axios(request).then( function(response) {
                
                response.handler( function(data){
                    self.state.actions.profile.setList(data.user.profiles);
                    self.checkProfileSelection();
                    //self.sensorList = data.sensors.providers[0].sensors;
                });
             
            }).catch(function (error) {
                // console.log(error);
            }).then(function () {
                self.loading = false;
                
                if (callback) {
                    callback(self);
                }
            });
            
        },
        addData: function (profile, callback) {
            let self = this;
                       
            let query = {
                query: `
                    mutation (
                        $label: String!,
                        $area: Int!
                        $cropId: String!,
                        $year: Int!,                         
                        $firstVegetationYear: Int
                    ) {
                       newProfile (
                        label: $label,
                        area: $area,
                        cropId: $cropId,
                        year: $year,                         
                        firstVegetationYear: $firstVegetationYear
                             ) {
                            success
                            result
                            profileId
                            profiles {
                                id
                                label
                                year
                                area
                                crop {
                                    id
                                    vegetationYears
                                    isPerennialCrop
                                    isRowCrop
                                }
                                weatherstation {
                                    id
                                    label
                                    provider
                                    altitude
                                },
                                allIrrigationsCompleted
                                waterPointId
                                totalWithdrawal
                            }
                          }
                        }
                `,      
                variables: {
                    label : profile.label,
                    area: profile.area,
                    cropId: profile.cropId,
                    year: profile.year,
                    firstVegetationYear: profile.firstVegetationYear
                }           
            }
            
            let request = Object.assign({}, self.config.request);
            request["data"] = query;
            
            self.loading = true;
            
            axios(request).then( function (response) {
                let data = response.data.data;
                
                if ( data !== null ) {
                    self.state.actions.profile.setList(data.newProfile.profiles);
                    let newProfile = self.profileById(data.newProfile.profileId)
                    self.year = newProfile.year;  
                    self.setProfile(newProfile);                    
                } else {
                    console.log(data); 
                }
            
            }).catch(function (error) {
                console.log(error);
            }).then(function () {
                self.loading = false;
                
                if (callback) {
                    callback(self);
                }
            });
        }
    },
    watch: {
        year: function (new_value) {
            // this.state.actions.profile.setYear(new_value);  
        }
    },
    created: function ()  {
        this.year = this.state.profile.year;
        this.fetchData();
    }
}


</script>
